import { createContext } from 'react';

const DRMValuesContext = createContext({
  copyEnabled: false,
  printEnabled: false,
  offlineEnabled: false,
  notesEnabled: false,
  flashcardsEnabled: false,
  collaborationEnabled: false,
});

export default DRMValuesContext;
